import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'map-pointer',
    templateUrl: 'mappointer.html',
    styleUrls: ['../../../assets/css/map.css', '../../../assets/css/map_rtl.scss'],


})
export class mappointer implements OnInit {
    @Input() lng: any = -0.12755;
    @Input() lat: any = 51.507222;
    //#region  Map Attributes  
    @Input() zoomLevel: number = 10;
    mapType: string = 'google';
    mapUrl: string = 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}';
    minZoom: number = 2;
    maxZoom: number = 20;
    centerLat: number = 30;
    centerLng: number = 30;

    private base_layer: any;
    private base_source: any;
    private vectorSource;
    private vectorLayer;
    private drawingGraphicSource: any;
    private drawingGraphicsLayer: any;
    private map: ol.Map;

    constructor() {
        this.SetMapDefualtAttributes(this.zoomLevel, this.mapType, this.mapUrl, this.minZoom, this.maxZoom);
    }
    private SetMapDefualtAttributes( _zoom, _baseMapType, _mapUrl, _minZoom, _maxZoom): void {
      
        this.mapType = _baseMapType ? _baseMapType : 'google';
        this.zoomLevel = _zoom ? _zoom : 10;
        this.minZoom = _minZoom ? _minZoom : 0;
        this.maxZoom = _maxZoom ? _maxZoom : 25;
        this.mapUrl = _mapUrl ? _mapUrl : 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}';
    }
    ngOnInit() {
        this.base_source = new ol.source.XYZ({ url: this.mapUrl });
        this.vectorLayer = new ol.layer.Vector({
            source: this.vectorSource,
        });
        this.vectorLayer.setZIndex(999);
        this.drawingGraphicsLayer = new ol.layer.Vector({
            source: this.drawingGraphicSource,
        });
        this.base_layer = new ol.layer.Tile({
            source: this.base_source

        });
        this.map = new ol.Map({
           layers: [this.base_layer, this.vectorLayer, this.drawingGraphicsLayer],
            target: document.getElementById('map'),
            view: new ol.View({
                center: ol.proj.transform([this.lng, this.lat], 'EPSG:4326', 'EPSG:3857'),
                zoom: this.zoomLevel,
                minZoom: this.minZoom,
                maxZoom: this.maxZoom
            })
        });
        var layer = new ol.layer.Vector({
            source: new ol.source.Vector({
                features: [
                    new ol.Feature({
                        geometry: new ol.geom.Point(ol.proj.fromLonLat([this.lng, this.lat]))
                    })
                ]
            }),
            style: new ol.style.Style({
                image: new ol.style.Icon({
                    color: '#fff',
                    crossOrigin: 'anonymous',
                    src: "/assets/img/map/Branch.png",
                    rotation: 0,

                })
            })
         
        });
        this.map .addLayer(layer);
       
    }


}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/mappointer/mappointer.ts